import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  messagesContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: 'calc(100vh - 100px)', // Altura ajustada para considerar o cabeçalho
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]:{
      height: '100vh'
    }
  },
  messagesList: {
    flex: 1,
    overflowX: 'hidden',
    overflowY: 'auto',
    padding: 0,
    marginBottom: theme.spacing(2),
    ...theme.scrollbarStyles // Certifique-se de que `theme.scrollbarStyles` esteja definido no seu tema
  },
  noMessages: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },
  recorderWrapper: {
    display: 'flex',
    alignItems: 'center',
    alignContent: 'middle',
    justifyContent: 'flex-end'
  },
  cancelAudioIcon: {
    color: 'red'
  },
  audioLoading: {
    color: theme.palette.green_200.main,
    opacity: '70%'
  },
  sendAudioIcon: {
    color: 'green'
  },
  quotedMessageContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_700.main
        : theme.palette.gray_50.main,
    borderRadius: '8px',
    padding: '8px',
    marginBottom: '8px',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    '& .MuiIconButton-sizeSmall': {
      backgroundColor: 'transparent'
    },
    '& svg': {
      cursor: 'pointer',
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main
    },
    '& svg:hover': {
      backgroundColor: 'transparent',
      color: theme.palette.red_100.main
    }
  },
  quotedMessage: {
    marginBotton: 5,
    marginTop: 5,
    borderWidth: '0 0 0 5px',
    borderStyle: 'solid',
    borderColor: theme.palette.green_200.main,
    paddingLeft: 5,
    maxHeight: 50,
    overflow: 'hidden'
  },
  inputContainer: {
    display: 'flex',
    gap: '4px',
    alignItems: 'center',
    padding: '8px 10px 2px 8px',
    '& p': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      maxWidth: '100%'
    }
  },
  messageInput: {
    flex: 1,
    marginRight: theme.spacing(1),
    '& .MuiOutlinedInput-root': {
      borderRadius: '8px'
    },
    '& .MuiInputBase-root': {
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main
    },
    '& input': {
      fontFamily: 'Noto Color Emoji, sans-serif'
    }
  },
  sendButton: {
    padding: '5px',
    borderRadius: '8px',
    height: '25px',
    backgroundColor: theme.palette.blue_300.main,
    color: 'white',
    '&:hover': {
      backgroundColor: theme.palette.blue_400.main
    }
  }
}))
